module.exports = "/dist/89614a6008fc5c60739012463d0ee7e6.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200italic.woff
// module id = 114
// module chunks = 0